module.exports = __webpack_public_path__ + "static/media/search.4a0ded71.svg";